export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        query_time: '查询时间',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        timely_reply_to_the_number_of_cases: '及时回复案例数量',
        prompt_response_percentage: '及时回复百分比',
        the_number_of_cases_was_not_timely_replied: '未及时回复案例数量',
        percentage_not_responding_in_time: '未及时回复百分比',
        parts_list: '零件清单',
        parts_num: '零件数量',
        sales_country: '销售国家',
        continuous_interval: '连续区间',
        cycle: '周期',
        growth_threshold: '增长率监控阈值',
        tech_inquiry_check: '关联技术问询清单',
        failed_part: '失效零件',
        symptoms: '故障现象',
        fault_cause: '故障原因',
        closing_statement: '结案说明',
        invoice_number: '单据号',
        primary_system: '一级系统',
        secondary_system: '二级系统',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        query_time: 'Query time',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Number of cases',
        timely_reply_to_the_number_of_cases: 'Timely reply to the number of cases',
        prompt_response_percentage: 'Prompt response percentage',
        the_number_of_cases_was_not_timely_replied: 'The number of cases was not timely replied',
        percentage_not_responding_in_time: 'Percentage not responding in time',
        parts_list: 'Parts List',
        parts_num: 'Part Quantity',
        sales_country: 'Sales Country',
        continuous_interval: 'Continuous Interval',
        cycle: 'Cycle',
        growth_threshold: 'Growth Threshold',
        tech_inquiry_check: 'Tech Inquiry Checklist',
        failed_part: 'System-part',
        symptoms: 'Fault phenomenon',
        fault_cause: 'Fault cause',
        closing_statement: 'Closing statement',
        invoice_number: 'Invoice Number',
        primary_system: 'Primary System',
        secondary_system: 'Secondary System',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        query_time: 'Abfragezeit',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        timely_reply_to_the_number_of_cases: 'Rechtzeitige Reaktion auf die Anzahl der Fälle',
        prompt_response_percentage: 'Prozentwert rechtzeitig wiederhergestellt',
        the_number_of_cases_was_not_timely_replied:
            'Wird die anzahl der fälle nicht rechtzeitig gemeldet',
        percentage_not_responding_in_time: 'Wurde nicht rechtzeitig über die prozent berichtet',
        parts_list: 'Teilliste', // 德语
        parts_num: 'Anzahl der Teile',
        sales_country: 'Verkaufsland',
        continuous_interval: 'Kontinuierliches Intervall',
        cycle: 'Zyklus',
        growth_threshold: 'Wachstumsschwelle',
        tech_inquiry_check: 'Tech-Anfrage-Checkliste',
        failed_part: 'Defekte Teile',
        symptoms: 'Fehlerphänomen',
        fault_cause: 'Fehlerursache',
        closing_statement: 'Akte geschlossen',
        invoice_number: 'Rechnungsnummer',
        primary_system: 'Primary System',
        secondary_system: 'Sekundäres System',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        reporting_organization_name: 'Nom de l\'organisation de rapport',
        full_query: 'Requête complète',
        query_time: 'Temps de requête',
        organization_code: 'Code d\'organisation',
        organization_name: 'Nom d\'organisation',
        country: 'Pays',
        number_of_cases: 'Nombre total de cas',
        timely_reply_to_the_number_of_cases: 'Réponse rapide au nombre de cas',
        prompt_response_percentage: 'Pourcentage de réponses rapides',
        the_number_of_cases_was_not_timely_replied: 'Nombre de cas en retard de réponse',
        percentage_not_responding_in_time: 'Pourcentage de réponses en retard',
        parts_list: 'Liste de pièces',
        parts_num: 'Anzahl der Teile',
        sales_country: 'Pays de vente',
        continuous_interval: 'Intervalle continu',
        cycle: 'Cycle',
        growth_threshold: 'Seuil croissance',
        tech_inquiry_check: 'Liste de contrôle technique',
        failed_part: 'Pièces affectées',
        symptoms: 'Défaut constaté',
        fault_cause: 'Cause du défaut',
        closing_statement: 'Note de clôture',
        invoice_number: 'Numéro de facture',
        primary_system: 'Primäres System',
        secondary_system: 'Système secondaire',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        query_time: 'Tempo di Query',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        timely_reply_to_the_number_of_cases: 'Risposta tempestiva al numero di casi',
        prompt_response_percentage: 'Percentuale di risposta tempestiva',
        the_number_of_cases_was_not_timely_replied:
            'Numero di casi che non hanno risposto tempestivamente',
        percentage_not_responding_in_time: 'Percentuale di risposte ritardate',
        parts_list: 'Elenco delle parti',
        parts_num: 'Quantità di parti',
        sales_country: 'Paese di vendita',
        continuous_interval: 'Intervallo continuo',
        cycle: 'Ciclo',
        growth_threshold: 'Soglia crescita',
        tech_inquiry_check: 'Elenco controllo tecnico',
        failed_part: 'Parte difettosa',
        symptoms: 'Sintomi del malfunzionamento',
        fault_cause: 'Causa del malfunzionamento',
        closing_statement: 'Dichiarazione di chiusura',
        invoice_number: 'Numero di fattura',
        primary_system: 'Système primaire',
        secondary_system: 'Sistema secondario',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        reporting_organization_name: 'Rapporterende organisatienaam',
        full_query: 'Volledige query',
        query_time: 'Query time',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        timely_reply_to_the_number_of_cases: 'Aantal gevallen',
        prompt_response_percentage: 'Percentage tijdige antwoorden',
        the_number_of_cases_was_not_timely_replied:
            'Aantal gevallen waarin niet tijdig is gereageerd',
        percentage_not_responding_in_time: 'Percentage niet-tijdige antwoorden',
        parts_list: 'Lijst van onderdelen',
        parts_num: 'Aantal onderdelen',
        sales_country: 'Verkoopland',
        continuous_interval: 'Continu interval',
        cycle: 'Cyclus',
        growth_threshold: 'Groei drempel',
        tech_inquiry_check: 'Technische controlelijst',
        failed_part: 'Getroffen onderdeel',
        symptoms: 'Foutverschijnselen',
        fault_cause: 'Foutoorzaak',
        closing_statement: 'Omschrijving van de zaak',
        invoice_number: 'Factuurnummer',
        primary_system: 'Primaire systeem',
        secondary_system: 'Secondaire systeem',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        query_time: 'Thời gian truy vấn',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Tổng số trường hợp',
        timely_reply_to_the_number_of_cases: 'Số lượng trả lời kịp thời cho các trường hợp',
        prompt_response_percentage: 'Phần trăm phản hồi kịp thời',
        the_number_of_cases_was_not_timely_replied:
            'Số lượng trường hợp không được trả lời kịp thời',
        percentage_not_responding_in_time: 'Phần trăm không phản hồi kịp thời',
        parts_list: 'Danh sách linh kiện',
        parts_num: 'Số lượng linh kiện',
        sales_country: 'Nước bán hàng',
        continuous_interval: 'Khoảng liên tục',
        cycle: 'Chu kỳ',
        growth_threshold: 'Ngưỡng tăng trưởng',
        tech_inquiry_check: 'Danh sách kiểm tra kỹ thuật',
        failed_part: 'Ảnh hưởng',
        symptoms: 'Hiện tượng lỗi',
        fault_cause: 'Nguyên nhân lỗi',
        closing_statement: 'Lời giải thích kết thúc',
        invoice_number: 'Số hóa đơn',
        primary_system: ' Hệ thống cấp một',
        secondary_system: 'Hệ thống cấp hai',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        reporting_organization_name: 'Nombre de la organización de informes',
        full_query: 'Consulta completa',
        query_time: 'Tiempo de consulta',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        timely_reply_to_the_number_of_cases: 'Número de casos respondidos a tiempo',
        prompt_response_percentage: 'Porcentaje de casos respondidos a tiempo',
        the_number_of_cases_was_not_timely_replied: 'Número de casos no respondidos a tiempo',
        percentage_not_responding_in_time: 'Porcentaje de casos no respondidos a tiempo',
        parts_list: 'Lista de piezas',
        parts_num: 'Cantidad de piezas',
        sales_country: 'País de venta',
        continuous_interval: 'Intervalo continuo',
        cycle: 'Ciclo',
        growth_threshold: 'Umbral crecimiento',
        tech_inquiry_check: 'Lista de verificación técnica',
        failed_part: 'Piezas defectuosas',
        symptoms: 'Síntoma de falla',
        fault_cause: 'Causa de falla',
        closing_statement: 'Explicación de cierre',
        invoice_number: 'Número de factura',
        primary_system: 'Sistema primario',
        secondary_system: 'Sistema secundario',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização de relatório',
        full_query: 'Consulta completa',
        query_time: 'Tempo de consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        timely_reply_to_the_number_of_cases: 'Número de respostas pontuais aos casos',
        prompt_response_percentage: 'Porcentagem de respostas pontuais',
        the_number_of_cases_was_not_timely_replied: 'Número de casos não respondidos pontualmente',
        percentage_not_responding_in_time: 'Porcentagem de casos não respondidos pontualmente',
        parts_list: 'Lista de peças',
        parts_num: 'Quantidade de peças',
        sales_country: 'País de venda',
        continuous_interval: 'Intervalo contínuo',
        cycle: 'Ciclo',
        growth_threshold: 'Limite crescimento',
        tech_inquiry_check: 'Lista de verificação técnica',
        failed_part: 'Peça com falha',
        symptoms: 'Sintomas',
        fault_cause: 'Causa da falha',
        closing_statement: 'Declaração de encerramento',
        invoice_number: 'Número da fatura',
        primary_system: 'Sistema primário',
        secondary_system: 'Sistema secundário',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        query_time: 'Data zapytania',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        timely_reply_to_the_number_of_cases: 'Liczba terminowych odpowiedzi',
        prompt_response_percentage: 'Liczba terminowych odpowiedzi (%)',
        the_number_of_cases_was_not_timely_replied: 'Liczba odpowiedzi nie udzielonych w terminie',
        percentage_not_responding_in_time: 'Liczba odpowiedzi nie udzielonych w terminie (%)',
        parts_list: 'Lista części',
        parts_num: 'Liczba części',
        sales_country: 'Kraj sprzedazy',
        continuous_interval: 'Ciągły przedział',
        cycle: 'Cyklus',
        growth_threshold: 'Prognoza wzrostu',
        tech_inquiry_check: 'Lista kontrolna techniczna',
        failed_part: 'Uszkodzona część',
        symptoms: 'zjawisko usterki',
        fault_cause: 'Przyczyna błędu',
        closing_statement: 'Wyajśnienie końcowe',
        invoice_number: 'Numer faktury',
        primary_system: 'Podstawowy system',
        secondary_system: 'Drugi system',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        query_time: 'Sorgulama zamanı',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Toplam dosyalar',
        timely_reply_to_the_number_of_cases: 'Zamanında cevaplanmış dosyalar',
        prompt_response_percentage: 'Hızlı cevaplama yüzdesi',
        the_number_of_cases_was_not_timely_replied: 'Zamanında cevaplanmamış dosya sayısı',
        percentage_not_responding_in_time: 'Zamanında cevaplanmış dosya  yüzdesi',
        parts_list: 'Parça listesi',
        parts_num: 'Parça sayısı',
        sales_country: 'Satış ülkesi',
        continuous_interval: 'Sürekli aralık',
        cycle: 'Döngü',
        growth_threshold: 'Büyüme eşiği',
        tech_inquiry_check: 'Teknik kontrol listesi',
        failed_part: 'Etkilendi',
        symptoms: 'Hata semptomu',
        fault_cause: 'Hata sebebi',
        closing_statement: 'Kapanış bildirimi',
        invoice_number: 'Fatura numarası',
        primary_system: 'Birinci derece sistem',
        secondary_system: 'İkinci derece sistem',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        query_time: 'Čas dotazu',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        timely_reply_to_the_number_of_cases: 'Včasná odpověď na počet případů',
        prompt_response_percentage: 'Procento rychlé odezvy',
        the_number_of_cases_was_not_timely_replied: 'Počet případů které nebyly včas odpovězeny',
        percentage_not_responding_in_time: 'Procento neodpovídá včas',
        parts_list: 'Seznam dílů',
        parts_num: 'Počet dílů',
        sales_country: 'Prodejní země',
        continuous_interval: 'Spojitý interval',
        cycle: 'Cyklus',
        growth_threshold: 'Rostoucí práh',
        tech_inquiry_check: 'Technická kontrolní lista',
        failed_part: 'Systémová část',
        symptoms: 'Fenomén závady',
        fault_cause: 'Příčina závady',
        closing_statement: 'Závěrečná zpráva',
        invoice_number: 'Číslo dokladu',
        primary_system: 'Primární systém',
        secondary_system: 'Sekundární systém',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        query_time: 'Lekérdezési idő',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        timely_reply_to_the_number_of_cases: 'Időben megválaszolt esetek száma',
        prompt_response_percentage: 'Azonnali válaszok százaléka',
        the_number_of_cases_was_not_timely_replied: 'Nem időben megválaszolt esetek száma',
        percentage_not_responding_in_time: 'Nem időben történt válaszok százaléka',
        parts_list: 'Részek listája',
        parts_num: 'Részek száma',
        sales_country: 'Eladási ország',
        continuous_interval: 'Folytonos intervallum',
        cycle: 'Ciklus',
        growth_threshold: 'Növekedési határérték',
        tech_inquiry_check: 'Technikai ellenőrzési lista',
        failed_part: 'Rendszer része',
        symptoms: 'Hibajelenség',
        fault_cause: 'Hiba oka',
        closing_statement: 'Lezárási nyilatkozat',
        invoice_number: 'Számlaszám',
        primary_system: 'Első szintű rendszer',
        secondary_system: 'Második szintű rendszer',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        query_time: 'Время запроса',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        timely_reply_to_the_number_of_cases: 'Количество случаев с своевременным ответом',
        prompt_response_percentage: 'Процент своевременных ответов',
        the_number_of_cases_was_not_timely_replied:
            'Количество случаев, на которые не был дан своевременный ответ',
        percentage_not_responding_in_time:
            'Процент случаев, на которые не был дан своевременный ответ',
        parts_list: 'Список деталей',
        parts_num: 'Количество деталей',
        sales_country: 'Страна продажи',
        continuous_interval: 'Непрерывный интервал',
        cycle: 'Цикл',
        growth_threshold: 'Порог роста',
        tech_inquiry_check: 'Технический контрольный список',
        failed_part: 'Неисправная деталь',
        symptoms: 'Симптом неисправности',
        fault_cause: 'Причина неисправности',
        closing_statement: 'Заключение по делу',
        invoice_number: 'Номер счета-фактуры',
        primary_system: 'Первая система',
        secondary_system: 'Вторая система',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        query_time: 'وقت الاستعلام',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        timely_reply_to_the_number_of_cases: 'عدد الحالات التي تم الرد عليها في الوقت المناسب',
        prompt_response_percentage: 'نسبة الردود في الوقت المناسب',
        the_number_of_cases_was_not_timely_replied:
            'عدد الحالات التي لم يتم الرد عليها في الوقت المناسب',
        percentage_not_responding_in_time: 'نسبة عدم الرد في الوقت المناسب',
        parts_list: 'قائمة القطع',
        parts_num: 'عدد القطع',
        sales_country: 'دولة البيع',
        continuous_interval: 'الفترة الزمنية المستمرة',
        cycle: 'الدورة',
        growth_threshold: 'عتبة مراقبة معدل النمو',
        tech_inquiry_check: 'قائمة الاستفسارات الفنية المرتبطة',
        failed_part: 'القطعة المعطلة',
        symptoms: 'أعراض العطل',
        fault_cause: 'سبب العطل',
        closing_statement: 'بيان الإغلاق',
        invoice_number: 'رقم المستند',
        primary_system: 'النظام الرئيسي',
        secondary_system: 'النظام الثانوي',
    },
    // 保加利亚语
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        query_time: 'Време на заявката',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        timely_reply_to_the_number_of_cases: 'Брой случаи с навременен отговор',
        prompt_response_percentage: 'Процент навременни отговори',
        the_number_of_cases_was_not_timely_replied: 'Брой случаи без навременен отговор',
        percentage_not_responding_in_time: 'Процент случаи без навременен отговор',
        parts_list: 'Списък с части',
        parts_num: 'Брой части',
        sales_country: 'Държава на продажба',
        continuous_interval: 'Непрекъснат интервал',
        cycle: 'Цикъл',
        growth_threshold: 'Праг за наблюдение на темпа на растеж',
        tech_inquiry_check: 'Списък със свързани технически запитвания',
        failed_part: 'Неизправна част',
        symptoms: 'Симптоми на неизправност',
        fault_cause: 'Причина за неизправността',
        closing_statement: 'Заключително изявление',
        invoice_number: 'Номер на документа',
        primary_system: 'Основна система',
        secondary_system: 'Вторична система',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        query_time: 'Forespørgselstidspunkt',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        timely_reply_to_the_number_of_cases: 'Antal sager besvaret rettidigt',
        prompt_response_percentage: 'Procentdel rettidige svar',
        the_number_of_cases_was_not_timely_replied: 'Antal sager ikke besvaret rettidigt',
        percentage_not_responding_in_time: 'Procentdel ikke rettidige svar',
        parts_list: 'Reservedelsliste',
        parts_num: 'Antal reservedele',
        sales_country: 'Salgsland',
        continuous_interval: 'Kontinuert interval',
        cycle: 'Cyklus',
        growth_threshold: 'Væksttærskel til overvågning',
        tech_inquiry_check: 'Relateret liste over tekniske forespørgsler',
        failed_part: 'Defekt komponent',
        symptoms: 'Fejlmanifestationer',
        fault_cause: 'Årsag til fejl',
        closing_statement: 'Afsluttende bemærkning',
        invoice_number: 'Dokumentnummer',
        primary_system: 'Primært system',
        secondary_system: 'Sekundært system',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        query_time: 'Hakuaika',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        timely_reply_to_the_number_of_cases: 'Ajoissa vastattujen tapausten määrä',
        prompt_response_percentage: 'Ajoissa vastattujen osuus',
        the_number_of_cases_was_not_timely_replied: 'Ei-aegaan vastattujen tapausten määrä',
        percentage_not_responding_in_time: 'Ei-aegaan vastattujen osuus',
        parts_list: 'Osaluettelo',
        parts_num: 'Osien määrä',
        sales_country: 'Myyntimaa',
        continuous_interval: 'Jatkuva aikaväli',
        cycle: 'Jakso',
        growth_threshold: 'Kasvun seurannan kynnysarvo',
        tech_inquiry_check: 'Liittyvien teknisten kyselyiden luettelo',
        failed_part: 'Viallinen osa',
        symptoms: 'Vian oireet',
        fault_cause: 'Vian syy',
        closing_statement: 'Sulkemiselvitys',
        invoice_number: 'Asiakirjan numero',
        primary_system: 'Ensisijainen järjestelmä',
        secondary_system: 'Toissijainen järjestelmä',
    },
    // 繁体中文（台湾）
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        query_time: '查詢時間',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        timely_reply_to_the_number_of_cases: '及時回覆案例數量',
        prompt_response_percentage: '及時回覆百分比',
        the_number_of_cases_was_not_timely_replied: '未及時回覆案例數量',
        percentage_not_responding_in_time: '未及時回覆百分比',
        parts_list: '零件清單',
        parts_num: '零件數量',
        sales_country: '銷售國家',
        continuous_interval: '連續區間',
        cycle: '週期',
        growth_threshold: '增長率監控閾值',
        tech_inquiry_check: '關聯技術詢問清單',
        failed_part: '失效零件',
        symptoms: '故障現象',
        fault_cause: '故障原因',
        closing_statement: '結案說明',
        invoice_number: '單據號',
        primary_system: '一級系統',
        secondary_system: '二級系統',
    },
    // 克罗地亚语
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        query_time: 'Vrijeme upita',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        timely_reply_to_the_number_of_cases: 'Broj slučajeva odgovorenih na vrijeme',
        prompt_response_percentage: 'Postotak pravovremenih odgovora',
        the_number_of_cases_was_not_timely_replied:
            'Broj slučajeva koji nisu odgovoreni na vrijeme',
        percentage_not_responding_in_time: 'Postotak nepravovremenih odgovora',
        parts_list: 'Popis dijelova',
        parts_num: 'Broj dijelova',
        sales_country: 'Zemlja prodaje',
        continuous_interval: 'Kontinuirani interval',
        cycle: 'Ciklus',
        growth_threshold: 'Prag praćenja rasta',
        tech_inquiry_check: 'Popis povezanih tehničkih upita',
        failed_part: 'Neispravan dio',
        symptoms: 'Simptomi kvara',
        fault_cause: 'Uzrok kvara',
        closing_statement: 'Obrazloženje zatvaranja',
        invoice_number: 'Broj dokumenta',
        primary_system: 'Primarni sustav',
        secondary_system: 'Sekundarni sustav',
    },
    // 拉脱维亚语
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        query_time: 'Vaicājuma laiks',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        timely_reply_to_the_number_of_cases: 'Laicīgi atbildēto gadījumu skaits',
        prompt_response_percentage: 'Laicīgu atbilžu procents',
        the_number_of_cases_was_not_timely_replied: 'Nelaicīgi atbildēto gadījumu skaits',
        percentage_not_responding_in_time: 'Nelaicīgu atbilžu procents',
        parts_list: 'Detaļu saraksts',
        parts_num: 'Detaļu skaits',
        sales_country: 'Pārdošanas valsts',
        continuous_interval: 'Nepārtraukts intervāls',
        cycle: 'Cikls',
        growth_threshold: 'Izaugsmes tempa uzraudzības slieksnis',
        tech_inquiry_check: 'Saistīto tehnisko vaicājumu saraksts',
        failed_part: 'Bojāta detaļa',
        symptoms: 'Kļūmes simptomi',
        fault_cause: 'Kļūmes iemesls',
        closing_statement: 'Slēgšanas paskaidrojums',
        invoice_number: 'Dokumenta numurs',
        primary_system: 'Primārā sistēma',
        secondary_system: 'Sekundārā sistēma',
    },
    // 立陶宛语
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        query_time: 'Užklausos laikas',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        timely_reply_to_the_number_of_cases: 'Laiku atsakytų atvejų skaičius',
        prompt_response_percentage: 'Laiku atsakytų atvejų procentas',
        the_number_of_cases_was_not_timely_replied: 'Ne laiku atsakytų atvejų skaičius',
        percentage_not_responding_in_time: 'Ne laiku atsakytų atvejų procentas',
        parts_list: 'Detalių sąrašas',
        parts_num: 'Detalių skaičius',
        sales_country: 'Pardavimo šalis',
        continuous_interval: 'Nuolatinis intervalas',
        cycle: 'Ciklas',
        growth_threshold: 'Augimo rodiklio stebėjimo slenkstis',
        tech_inquiry_check: 'Susijusių techninių užklausų sąrašas',
        failed_part: 'Sugesusi detalė',
        symptoms: 'Gedimo požymiai',
        fault_cause: 'Gedimo priežastis',
        closing_statement: 'Užbaigimo paaiškinimas',
        invoice_number: 'Dokumento numeris',
        primary_system: 'Pagrindinė sistema',
        secondary_system: 'Antrinė sistema',
    },
    // 罗马尼亚语
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        query_time: 'Timpul interogării',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        timely_reply_to_the_number_of_cases: 'Numărul de cazuri răspunse în timp util',
        prompt_response_percentage: 'Procentul răspunsurilor în timp util',
        the_number_of_cases_was_not_timely_replied: 'Numărul de cazuri fără răspuns în timp util',
        percentage_not_responding_in_time: 'Procentul cazurilor fără răspuns în timp util',
        parts_list: 'Listă piese',
        parts_num: 'Numărul pieselor',
        sales_country: 'Țara de vânzare',
        continuous_interval: 'Interval continuu',
        cycle: 'Ciclu',
        growth_threshold: 'Prag de monitorizare a ratei de creștere',
        tech_inquiry_check: 'Listă cu întrebări tehnice asociate',
        failed_part: 'Piesă defectă',
        symptoms: 'Simptome ale defecțiunii',
        fault_cause: 'Cauza defecțiunii',
        closing_statement: 'Declarație de închidere',
        invoice_number: 'Număr document',
        primary_system: 'Sistem primar',
        secondary_system: 'Sistem secundar',
    },
    // 挪威博克马尔语
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        query_time: 'Spørringstidspunkt',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        timely_reply_to_the_number_of_cases: 'Antall saker besvart i tide',
        prompt_response_percentage: 'Prosentandel tidlige svar',
        the_number_of_cases_was_not_timely_replied: 'Antall saker ikke besvart i tide',
        percentage_not_responding_in_time: 'Prosentandel saker ikke besvart i tide',
        parts_list: 'Reservedelsliste',
        parts_num: 'Antall reservedeler',
        sales_country: 'Salgsland',
        continuous_interval: 'Kontinuerlig intervall',
        cycle: 'Syklus',
        growth_threshold: 'Terskelverdi for vekstovervåkning',
        tech_inquiry_check: 'Relatert liste over tekniske henvendelser',
        failed_part: 'Defekt del',
        symptoms: 'Feilfenomener',
        fault_cause: 'Feilårsak',
        closing_statement: 'Avslutningsmerknad',
        invoice_number: 'Dokumentnummer',
        primary_system: 'Primært system',
        secondary_system: 'Sekundært system',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        query_time: 'Horário da consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        timely_reply_to_the_number_of_cases: 'Quantidade de casos respondidos em tempo hábil',
        prompt_response_percentage: 'Percentual de respostas em tempo hábil',
        the_number_of_cases_was_not_timely_replied:
            'Quantidade de casos não respondidos em tempo hábil',
        percentage_not_responding_in_time: 'Percentual de casos não respondidos em tempo hábil',
        parts_list: 'Lista de peças',
        parts_num: 'Quantidade de peças',
        sales_country: 'País de venda',
        continuous_interval: 'Intervalo contínuo',
        cycle: 'Ciclo',
        growth_threshold: 'Limiar de monitoramento da taxa de crescimento',
        tech_inquiry_check: 'Lista de consultas técnicas associadas',
        failed_part: 'Peça com falha',
        symptoms: 'Sintomas da falha',
        fault_cause: 'Causa da falha',
        closing_statement: 'Declaração de encerramento',
        invoice_number: 'Número do documento',
        primary_system: 'Sistema primário',
        secondary_system: 'Sistema secundário',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        query_time: 'Förfråganstidpunkt',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        timely_reply_to_the_number_of_cases: 'Antal ärenden besvarade i tid',
        prompt_response_percentage: 'Andel ärenden besvarade i tid (%)',
        the_number_of_cases_was_not_timely_replied: 'Antal ärenden ej besvarade i tid',
        percentage_not_responding_in_time: 'Andel ärenden ej besvarade i tid (%)',
        parts_list: 'Reservdelslista',
        parts_num: 'Antal reservdelar',
        sales_country: 'Säljland',
        continuous_interval: 'Kontinuerligt intervall',
        cycle: 'Cykel',
        growth_threshold: 'Tröskelvärde för tillväxtövervakning',
        tech_inquiry_check: 'Lista över relaterade tekniska förfrågningar',
        failed_part: 'Defekt komponent',
        symptoms: 'Felsymtom',
        fault_cause: 'Felorsak',
        closing_statement: 'Avslutande kommentar',
        invoice_number: 'Dokumentnummer',
        primary_system: 'Primärt system',
        secondary_system: 'Sekundärt system',
    },
    // 斯洛伐克语
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        query_time: 'Čas dopytu',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        timely_reply_to_the_number_of_cases: 'Počet prípadov odpovedaných včas',
        prompt_response_percentage: 'Percento včasných odpovedí',
        the_number_of_cases_was_not_timely_replied: 'Počet prípadov bez včasnej odpovede',
        percentage_not_responding_in_time: 'Percento prípadov bez včasnej odpovede',
        parts_list: 'Zoznam súčiastok',
        parts_num: 'Počet súčiastok',
        sales_country: 'Predajná krajina',
        continuous_interval: 'Kontinuálny interval',
        cycle: 'Cyklus',
        growth_threshold: 'Prah sledovania miery rastu',
        tech_inquiry_check: 'Zoznam súvisiacich technických otázok',
        failed_part: 'Poruchová súčiastka',
        symptoms: 'Príznaky poruchy',
        fault_cause: 'Príčina poruchy',
        closing_statement: 'Záverečné vyhlásenie',
        invoice_number: 'Číslo dokladu',
        primary_system: 'Primárny systém',
        secondary_system: 'Sekundárny systém',
    },
    // 斯洛文尼亚语
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        query_time: 'Čas poizvedbe',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        timely_reply_to_the_number_of_cases: 'Število primerov, odgovorjenih pravočasno',
        prompt_response_percentage: 'Odstotek pravočasnih odgovorov',
        the_number_of_cases_was_not_timely_replied:
            'Število primerov, ki niso bili odgovorjeni pravočasno',
        percentage_not_responding_in_time: 'Odstotek nepravočasnih odgovorov',
        parts_list: 'Seznam delov',
        parts_num: 'Število delov',
        sales_country: 'Država prodaje',
        continuous_interval: 'Neprekinjen interval',
        cycle: 'Cikel',
        growth_threshold: 'Meja spremljanja stopnje rasti',
        tech_inquiry_check: 'Seznam povezanih tehničnih poizvedb',
        failed_part: 'Okvarjen del',
        symptoms: 'Simptomi okvare',
        fault_cause: 'Vzrok okvare',
        closing_statement: 'Obrazložitev zaključka',
        invoice_number: 'Številka dokumenta',
        primary_system: 'Primarni sistem',
        secondary_system: 'Sekundarni sistem',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        query_time: 'เวลาการสอบถาม',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        timely_reply_to_the_number_of_cases: 'จำนวนกรณีที่ตอบกลับตรงเวลา',
        prompt_response_percentage: 'เปอร์เซ็นต์การตอบกลับตรงเวลา',
        the_number_of_cases_was_not_timely_replied: 'จำนวนกรณีที่ไม่ได้ตอบกลับตรงเวลา',
        percentage_not_responding_in_time: 'เปอร์เซ็นต์กรณีที่ไม่ได้ตอบกลับตรงเวลา',
        parts_list: 'รายการชิ้นส่วน',
        parts_num: 'จำนวนชิ้นส่วน',
        sales_country: 'ประเทศที่ขาย',
        continuous_interval: 'ช่วงเวลาต่อเนื่อง',
        cycle: 'รอบระยะเวลา',
        growth_threshold: 'เกณฑ์เฝ้าระวังอัตราการเติบโต',
        tech_inquiry_check: 'รายการคำถามทางเทคนิคที่เกี่ยวข้อง',
        failed_part: 'ชิ้นส่วนที่เสียหาย',
        symptoms: 'อาการขัดข้อง',
        fault_cause: 'สาเหตุของความผิดพลาด',
        closing_statement: 'คำอธิบายปิดเคส',
        invoice_number: 'หมายเลขเอกสาร',
        primary_system: 'ระบบหลัก',
        secondary_system: 'ระบบย่อย',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        query_time: 'Час запиту',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        timely_reply_to_the_number_of_cases: 'Кількість випадків з відповіддю вчасно',
        prompt_response_percentage: 'Відсоток вчасних відповідей',
        the_number_of_cases_was_not_timely_replied: 'Кількість випадків без вчасної відповіді',
        percentage_not_responding_in_time: 'Відсоток невчасних відповідей',
        parts_list: 'Перелік деталей',
        parts_num: 'Кількість деталей',
        sales_country: 'Країна продажу',
        continuous_interval: 'Неперервний інтервал',
        cycle: 'Цикл',
        growth_threshold: 'Поріг моніторингу темпу зростання',
        tech_inquiry_check: 'Пов’язаний перелік технічних запитів',
        failed_part: 'Несправна деталь',
        symptoms: 'Ознаки несправності',
        fault_cause: 'Причина несправності',
        closing_statement: 'Пояснення закриття',
        invoice_number: 'Номер документа',
        primary_system: 'Основна система',
        secondary_system: 'Допоміжна система',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        query_time: 'Χρόνος ερωτήματος',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        timely_reply_to_the_number_of_cases: 'Αριθμός περιστατικών με έγκαιρη απάντηση',
        prompt_response_percentage: 'Ποσοστό έγκαιρων απαντήσεων',
        the_number_of_cases_was_not_timely_replied: 'Αριθμός περιστατικών χωρίς έγκαιρη απάντηση',
        percentage_not_responding_in_time: 'Ποσοστό περιστατικών χωρίς έγκαιρη απάντηση',
        parts_list: 'Λίστα εξαρτημάτων',
        parts_num: 'Πλήθος εξαρτημάτων',
        sales_country: 'Χώρα πώλησης',
        continuous_interval: 'Συνεχής διάστημα',
        cycle: 'Κύκλος',
        growth_threshold: 'Κατώφλι παρακολούθησης ρυθμού ανάπτυξης',
        tech_inquiry_check: 'Σχετική λίστα τεχνικών ερωτημάτων',
        failed_part: 'Ελαττωματικό εξάρτημα',
        symptoms: 'Συμπτώματα βλάβης',
        fault_cause: 'Αιτία βλάβης',
        closing_statement: 'Δήλωση κλεισίματος',
        invoice_number: 'Αριθμός εγγράφου',
        primary_system: 'Πρωτεύον σύστημα',
        secondary_system: 'Δευτερεύον σύστημα',
    },
    // 爱沙尼亚语
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        query_time: 'Päringu aeg',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        timely_reply_to_the_number_of_cases: 'Õigeaegselt vastatud juhtumite arv',
        prompt_response_percentage: 'Õigeaegsete vastuste protsent',
        the_number_of_cases_was_not_timely_replied: 'Mitte õigeaegselt vastatud juhtumite arv',
        percentage_not_responding_in_time: 'Mitte õigeaegsete vastuste protsent',
        parts_list: 'Osaliste loend',
        parts_num: 'Osaliste arv',
        sales_country: 'Müügiriik',
        continuous_interval: 'Pidev ajavahemik',
        cycle: 'Tsükkel',
        growth_threshold: 'Kasvu jälgimise lävi',
        tech_inquiry_check: 'Seotud tehniliste päringute loend',
        failed_part: 'Rikkestatud osa',
        symptoms: 'Rikke sümptomid',
        fault_cause: 'Rikke põhjus',
        closing_statement: 'Sulgemise selgitus',
        invoice_number: 'Dokumendi number',
        primary_system: 'Esmane süsteem',
        secondary_system: 'Teisene süsteem',
    },
    // 哈萨克语
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        query_time: 'Сұрау уақыты',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        timely_reply_to_the_number_of_cases: 'Уақытында жауап берілген жағдайлар саны',
        prompt_response_percentage: 'Уақытында жауап беру пайызы',
        the_number_of_cases_was_not_timely_replied: 'Уақытында жауап берілмеген жағдайлар саны',
        percentage_not_responding_in_time: 'Уақытында жауап берілмеу пайызы',
        parts_list: 'Бөлшектер тізімі',
        parts_num: 'Бөлшектер саны',
        sales_country: 'Сату елі',
        continuous_interval: 'Үздіксіз аралық',
        cycle: 'Цикл',
        growth_threshold: 'Өсу қарқынын бақылау табалдырығы',
        tech_inquiry_check: 'Қатысты техникалық сұрақтар тізімі',
        failed_part: 'Сәтсіз бөлшек',
        symptoms: 'Ақау белгілері',
        fault_cause: 'Ақау себебі',
        closing_statement: 'Жабу туралы түсіндірме',
        invoice_number: 'Құжат нөмірі',
        primary_system: 'Бірінші деңгейлі жүйе',
        secondary_system: 'Екінші деңгейлі жүйе',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        query_time: 'זמן השאילתה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        timely_reply_to_the_number_of_cases: 'כמות מקרים עם תגובה בזמן',
        prompt_response_percentage: 'אחוז תגובות בזמן',
        the_number_of_cases_was_not_timely_replied: 'כמות מקרים ללא תגובה בזמן',
        percentage_not_responding_in_time: 'אחוז מקרים ללא תגובה בזמן',
        parts_list: 'רשימת חלקים',
        parts_num: 'כמות החלקים',
        sales_country: 'מדינת מכירה',
        continuous_interval: 'טווח רציף',
        cycle: 'מחזור',
        growth_threshold: 'סף ניטור שיעור הצמיחה',
        tech_inquiry_check: 'רשימת שאילתות טכניות קשורות',
        failed_part: 'רכיב כשל',
        symptoms: 'תסמיני תקלה',
        fault_cause: 'סיבת התקלה',
        closing_statement: 'הצהרת סגירה',
        invoice_number: 'מספר המסמך',
        primary_system: 'מערכת ראשית',
        secondary_system: 'מערכת משנית',
    },
};
